$('.myintimissimi-advantages-carousel').slick({
    dots: false,
    infinite: false,
    arrows: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 769,
            settings: {
                dots: false,
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 639,
            settings: {
                dots: true,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});

$('.myintimissimi-three-steps').slick({
    dots: false,
    infinite: false,
    arrows: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 769,
            settings: {
                dots: false,
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 639,
            settings: {
                dots: true,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});

$('.myintimissimi-full-carousel').slick({
    dots: false,
    infinite: false,
    arrows: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 769,
            settings: {
                dots: false,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 639,
            settings: {
                dots: false,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});

$(document).ready(function () {
    $('ul.card-tabs-myintimissimi li:first').addClass('active');
    $('.mycard-tab-js:first').addClass('mycard-tab-show'); // Mostra il contenuto della prima tab
    $('.myintimissimi-advantages-carousel').slick('refresh');

    $('ul.card-tabs-myintimissimi li').click(function () {
        $('.myintimissimi-advantages-carousel').slick('refresh');
        $('ul.card-tabs-myintimissimi li').removeClass('active');
        $('.mycard-tab-js').removeClass('mycard-tab-show'); // Rimuovi ogni classe "active"
        $(this).addClass('active'); // E aggiungila solo a quella su cui ho cliccato

        var activeTab = $(this).find('a').attr('href'); // Trova l'href per identificare in modo univoco la tab ed il contenuto
        $(activeTab).addClass('mycard-tab-show'); // Mostrami quest'ultimo con effetto di fadeIn
        return false;
    });
});
